<template>
  <v-sheet width="100%" class="pb-4">
    <div class="mx-4 mt-4">
      <v-alert v-if="alertText" text outlined :type="alertType">
        {{ alertText }}
      </v-alert>
      <v-card>
        <v-card-title class="headline"> Actualizar Contraseña </v-card-title>
        <v-card-text class="text-left">
          <v-form
            ref="passwordForm"
            v-model="localValidForm"
            @submit.prevent="changePassword"
          >
            <password-form
              ref="passwordInputs"
              :value="passwordForm"
              @input="updatePasswordForm"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success darken-1"
            :loading="updatingPassword"
            :disabled="!localValidForm"
            @click="changePassword"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-sheet>
</template>

<script>
  import PasswordForm from '@/components/forms/PasswordForm';
  import { mapState, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'UpdatePasswordModal',

    components: {
      PasswordForm,
    },

    props: {
      value: {
        type: Boolean,
        default: true,
      },
      alertText: {
        type: String,
        default: null,
      },
      alertType: {
        type: String,
        default: null,
      },
    },

    data() {
      return {
        localValidForm: false,
      };
    },
    computed: {
      ...mapState('updatePassword', ['passwordForm', 'updatingPassword']),
      showModal: {
        get() {
          return this.value;
        },
        set(newValue) {
          if (!newValue) {
            this.resetForm();
          }
          this.$emit('input', newValue);
        },
      },
    },
    watch: {
      localValidForm(newValue) {
        this.SET_VALID_FORM(newValue);
      },
    },
    methods: {
      ...mapActions('modalStepsAfterLogin', [
        'findStepByKey',
        'updateStepStatus',
      ]),
      ...mapActions('updatePassword', ['updatePassword']),
      ...mapMutations('updatePassword', [
        'SET_VALID_FORM',
        'RESET_FORM',
        'UPDATE_PASSWORD_FORM',
      ]),
      ...mapMutations('modalStepsAfterLogin', ['REMOVE_STEP']),

      updatePasswordForm(newValue) {
        // Actualizar cada campo del formulario individualmente
        Object.entries(newValue).forEach(([field, value]) => {
          this.UPDATE_PASSWORD_FORM({ field, value });
        });
      },

      async validate() {
        if (this.$refs.passwordForm) {
          const isValid = await this.$refs.passwordForm.validate();
          this.SET_VALID_FORM(isValid);
          return isValid;
        }
        return false;
      },

      async changePassword() {
        const isValid = await this.validate();
        if (!isValid) return;

        const username = localStorage.getItem('username');
        if (!username) {
          return;
        }

        const { error } = await this.updatePassword({
          username,
        });

        if (error) {
          this.$toast.error(error.description, {
            timeout: 3000,
          });

          return;
        }

        const updateStep = await this.findStepByKey('updatePassword');
        if (updateStep) {
          this.REMOVE_STEP('updatePassword');
        }
        await this.$refs.passwordForm.resetValidation();
        if (this.$refs.passwordInputs?.resetRulesCheckList) {
          this.$refs.passwordInputs.resetRulesCheckList();
        }

        this.$toast.success('Contraseña Actualizada Correctamente', {
          timeout: 3000,
        });
      },

      resetForm() {
        this.RESET_FORM();
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.resetValidation();
        }
        if (this.$refs.passwordInputs?.resetRulesCheckList) {
          this.$refs.passwordInputs.resetRulesCheckList();
        }
        this.localValidForm = false;
      },
    },
  };
</script>
